import {
    BannerCloseWrapperStyled,
    BannerContainerStyled,
    BannerContentStyled,
    BannerDescriptionStyled,
    BannerStyled,
    BannerTitleStyled,
} from './styled/BannerStyled';
import BinIcon from '../../../components/icon/Icon';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import BannerPrimaryButton from '../BannerPrimaryButton/BannerPrimaryButton';
import { useCallback } from 'react';
import { TBannerLocation } from '../banners.t';
import TimerBadge from '../../../components/TimerBadge/TimerBadge';

interface IBannerProps {
    background: string,
    backgroundImageSize?: string,
    backgroundImageUrl?: string,
    bannerName: string,
    buttonBackground?: string,
    buttonTitle: string | null,
    description: string | null,
    location: TBannerLocation,
    onClick?: (bannerName: string, location: string) => void,
    onClose?: (bannerName: string, location: string) => void,
    short?: boolean,
    textColor?: string,
    timerSecondsLeft?: number,
    title: string | null,
}

function Banner(props: IBannerProps) {
    const {
        background,
        backgroundImageSize,
        backgroundImageUrl,
        bannerName,
        buttonBackground,
        buttonTitle,
        description,
        location,
        onClick,
        onClose,
        short,
        textColor,
        timerSecondsLeft,
        title,
    } = props;
    const { getLangPath } = useLangContext();

    const onClickHandler = useCallback(() => {
        onClick && onClick(bannerName, location);
    }, [bannerName, location, onClick]);

    const onCloseHandler = useCallback((e) => {
        e.stopPropagation();
        onClose && onClose(bannerName, location);
    }, [onClose, bannerName, location]);

    return <BannerStyled
        background={background}
        data-name={bannerName}
        data-location={location}
        onClick={short ? onClickHandler : undefined}
        textColor={textColor}
    >
        <BannerContentStyled
            backgroundImageSize={backgroundImageSize}
            backgroundImageUrl={backgroundImageUrl}
        >
            <BannerContainerStyled>
                <BannerTitleStyled>
                    <span className={'ellipsis'}>
                        {title || '\u00A0'}
                    </span>
                </BannerTitleStyled>
                {!!timerSecondsLeft
                    ? <TimerBadge secondsLeft={timerSecondsLeft}/>
                    : <BannerCloseWrapperStyled onClick={onCloseHandler}>
                        <BinIcon name={'IcClose'}/>
                    </BannerCloseWrapperStyled>
                }
            </BannerContainerStyled>
            <BannerDescriptionStyled className={'ellipsis'}>
                {description || '\u00A0'}
            </BannerDescriptionStyled>
            {
                !short && <div className={'d-flex flex-column mt-2'}>
                    <BannerPrimaryButton
                        background={buttonBackground}
                        onClick={onClickHandler}
                    >
                        {
                            buttonTitle ||
                            getLangPath('banners.default.button')
                        }
                    </BannerPrimaryButton>
                </div>
            }
        </BannerContentStyled>
    </BannerStyled>;
}

export default Banner;
